import { render, staticRenderFns } from "./BIContainer.vue?vue&type=template&id=3070ccac&scoped=true"
import script from "./BIContainer.vue?vue&type=script&lang=js"
export * from "./BIContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3070ccac",
  null
  
)

export default component.exports